/**
 * Нягтлан Excel: огноо/сар = Asia/Ulaanbaatar (+8).
 * API-аас ирсэн UTC ISO-г УБ өдрөөр харуулна.
 */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const BUSINESS_TZ = "Asia/Ulaanbaatar";

export function formatInUlaanbaatar(value, fmt = "YYYY-MM-DD HH:mm:ss") {
  if (value == null || value === "") return "";
  const d = dayjs(value);
  if (!d.isValid()) return "";
  return d.tz(BUSINESS_TZ).format(fmt);
}

export function monthKeyInUlaanbaatar(value) {
  if (value == null || value === "") return "Огноогүй";
  const d = dayjs(value);
  if (!d.isValid()) return "Огноогүй";
  return d.tz(BUSINESS_TZ).format("YYYY-MM");
}

/** Calendar range → API createdAt param (UB өдөр, API buildInvoiceListWhere-тай ижил). */
export function formatUbCreatedAtRange(range) {
  if (!range?.[0] || !range?.[1]) return null;
  const startDay = dayjs(range[0]).format("YYYY-MM-DD");
  const endDay = dayjs(range[1]).format("YYYY-MM-DD");
  const start = dayjs
    .tz(`${startDay} 00:00:00`, BUSINESS_TZ)
    .format("YYYY-MM-DD HH:mm:ss");
  const end = dayjs
    .tz(`${endDay} 23:59:59`, BUSINESS_TZ)
    .format("YYYY-MM-DD HH:mm:ss");
  return `${start}->${end}`;
}

export function formatUbRangeLabel(range) {
  if (!range?.[0] || !range?.[1]) return "—";
  const startDay = dayjs(range[0]).format("YYYY-MM-DD");
  const endDay = dayjs(range[1]).format("YYYY-MM-DD");
  return `${startDay} — ${endDay} (${BUSINESS_TZ})`;
}
